import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import SinglePatientInfo from '../../Components/Global_Components/common/SinglePatientInfo';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import SelectField from '../../Components/Global_Components/form/SelectField';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {fetchPatientDetailsUuid, postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {handleNill, renderDynamicTable, renderReportfield, renderTableTD, renderTableTH} from '../../utils/templateUtils';
import './secondMonthPregnancy.scss';

export default function SecondMonthPregnancy(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });

  const [investigationRows, setInvestigationRows] = useState([
    {investigation: 'Blood Group and Rh typing', result: ''},
    {investigation: 'Complete Blood Count (CBC)', result: ''},
    {investigation: 'TSH & Free T4', result: ''},
    {investigation: 'Urea, Creatinine', result: ''},
    {investigation: 'Random Blood Sugar / HbA1c / GCT with 75g Glucos', result: ''},
    {investigation: 'HIV, HBsAg, VDRL, Anti-HCV', result: ''},
    {investigation: 'Rubella IgG', result: ''},
    {investigation: 'Urine Routine and Culture', result: ''}
  ]);

  const [showTables, setShowTables] = useState({
    investigation: true,
    medication: true
  });

  const [medicationRows, setMedicationRows] = useState([
    {
      sno: '1',
      drug: 'T. Furnext / Globac XT/ Ferronomic plus',
      genericName: 'Ferrous bisglycinate + Folic Acid + Zinc + Methylcobalamin',
      dosage: '',
      freq: '0-1-0',
      withFood: 'after food',
      duration: '30 Days'
    },
    {
      sno: '2',
      drug: 'Folvista / Trafolic / Folinext Gold',
      genericName: 'Folic Acid',
      dosage: '0-0-1',
      freq: 'Once daily',
      withFood: 'After food',
      duration: '30 days'
    },
    {
      sno: '3',
      drug: 'Vomibune',
      genericName: 'Doxylamine + Pyridoxine',
      dosage: '1-1-1 (max 2 tabs thrice)',
      freq: 'Up to TID PRN',
      withFood: 'Before Food',
      duration: 'SOS'
    },
    {
      sno: '4',
      drug: 'Evaraft',
      genericName: 'Sodium Alginate + Bicarbonate + CaCO₃',
      dosage: '10 ml',
      freq: 'Twice daily PRN',
      withFood: 'After food',
      duration: 'SOS'
    },
    {
      sno: '5',
      drug: 'Vivamom',
      genericName: 'Maternal Protein Supplement',
      dosage: '2 tsp',
      freq: 'Once/Twice Daily',
      withFood: 'With Milk, Between Meals',
      duration: '30 days'
    },
    {
      sno: '6',
      drug: 'Dydrofirst / Dydraboone',
      genericName: 'Dydrogesterone',
      dosage: '10 mg',
      freq: 'Three Times Daily (TID)',
      withFood: 'After food',
      duration: '30 days'
    },
    {
      sno: '7',
      drug: 'C. Gestobond',
      genericName: 'Micronized Progesterone Vaginal Capsule',
      dosage: '400 mg',
      freq: 'Twice Daily (BD) Vaginally',
      withFood: '-',
      duration: '30 days'
    },
    {
      sno: '8',
      drug: 'Tab. Ecosprin 75/150',
      genericName: 'Low-dose Aspirin',
      dosage: '-',
      freq: '0-0-1',
      withFood: 'in the night after meal',
      duration: '30 days'
    },
    {
      sno: '9',
      drug: 'T. CVit',
      genericName: 'Ascorbic Acid (Vitamin C)',
      dosage: '',
      freq: '0-1-0',
      withFood: 'After food',
      duration: '30 Days'
    },
    {
      sno: '10',
      drug: 'T. Neuroplex',
      genericName: 'Multivitamin B-complex with Vitamin C',
      dosage: '',
      freq: '0-0-1',
      withFood: 'After food',
      duration: '30 Days'
    },
    {
      sno: '11',
      drug: 'INJ INFLUVAC TETRA',
      genericName: 'INACTIVATED INFLUENZA VACCINE(QUADRIVALENT)',
      dosage: '1 AMP IM',
      freq: 'STAT',
      withFood: '-',
      duration: '-'
    },
    {
      sno: '12',
      drug: 'Tab. Ecosprin 75/150',
      genericName: 'Aspirin 75/150 mg',
      dosage: '1 tablet',
      freq: '0-0-1',
      withFood: 'in the night after meal',
      duration: 'Till 34 weeks'
    },
    {
      sno: '13',
      drug: 'Thyronorm',
      genericName: 'Levothyroxine (as per TSH)',
      dosage: '1 tablet',
      freq: '1-0-0',
      withFood: 'Oral',
      timing: 'Empty stomach',
      duration: 'As advised',
      remarks: 'Avoid food for 30 mins post intake'
    },
    {
      sno: '14',
      drug: 'V-Wash',
      genericName: 'Mild pH-balanced cleanser',
      dosage: 'Coin-size',
      freq: 'As needed',
      withFood: 'As advised',
      timing: '—',
      duration: '—',
      remarks: 'If irritation with vaginal medications'
    },
    {
      sno: '15',
      drug: 'Trapic',
      genericName: 'Tranexamic Acid + Mefenamic Acid ',
      dosage: 'As advised',
      freq: 'As needed',
      withFood: 'As advised',
      timing: '—',
      duration: '—',
      remarks: 'As advised'
    },
    {
      sno: '16',
      drug: 'T.HCQ',
      genericName: 'Plaquenil',
      dosage: '200 ml',
      freq: '1-0-1',
      withFood: 'As advised',
      timing: '—',
      duration: '—',
      remarks: 'After food for 30 Days'
    },
    {
      sno: '17',
      drug: 'Tab. Glycomet SR',
      genericName: 'Metformin',
      dosage: '500 mg',
      freq: '1-0-1',
      withFood: 'After food',
      duration: '30 days'
    }
  ]);

  const investigationHeaders = [
    {key: 'investigation', label: 'Investigation'},
    {key: 'result', label: 'Result'}
  ];

  const medicationHeaders = [
    {key: 'sno', label: 'S.No'},
    {key: 'drug', label: 'Specific Name (Brand)'},
    {key: 'genericName', label: 'Generic Name'},
    {key: 'dosage', label: 'Dosage'},
    {key: 'freq', label: 'Frequency'},
    {key: 'withFood', label: 'Relation to food'},
    {key: 'duration', label: 'Duration'}
  ];

  const handleChange = e => {
    var text = e.target.value;

    if (e.target.name === 'patientId') {
      if (e.target.value.length === 10 && e.target.value.charAt(0) === 'A') {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value
          };
          props.loaderchange('true');
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat = data?.titles + ' ' + data?.first_name + ' ' + data?.last_name;
            if (e.target.name === 'patientId') {
              setFormData({
                ...formData,
                patientName: namePat,
                age: data?.age,
                gender: data?.gender,
                patientId: text
              });
            }
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === 'patientId') {
          setFormData({
            ...formData,
            patientId: e.target.value
          });
        }
      }
    } else {
      setFormData({...formData, [e.target.name]: e.target.value});
      if (e.target.name === 'nextappointment') {
        const dateTime = e.target.value.split('T');
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: 'Not Visited',
          notes: 'Booking Visit',
          patient_id: patientId
        });
      }
    }
  };

  const handlesubmit = () => {
    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && props.patientsData.p_uhid.length === 10) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('secondMonthPregnancyReportWrap').innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'Spontaneous Pregnancy - 2 Month'
            }
          };

          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  return (
    <div id='SecondMonthPregnancyTemplate'>
      <div className='SecondMonthPregnancyTemplate'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img
              className='header_image'
              src={headerimage}
              style={{
                width: '100%',
                margin: '0 auto'
              }}></img>
          </div>
          <h2 style={{display: 'flex', justifyContent: 'center'}}>Spontaneous Pregnancy – 2 Month</h2>

          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />
        </div>
        <div className='detail'>
          <h3 className='mt-3'>OBSTETRIC SCORE :</h3>
          <div className='row'>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='G:' name='g' value={formData.g} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='P:' name='p' value={formData.p} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='A:' name='a' value={formData.a} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='L:' name='l' value={formData.l} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Ectopic:' name='ecTopic' value={formData.ecTopic} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>
          <div className='row mt-3'>
            <div className='col-md-6'>
              <ReportFormInputWithLabel
                label='GESTATIONAL AGE:'
                name='gestationalAge'
                value={formData.gestationalAge}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                endLabel='Weeks'
                minWidth='200px'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='BP:' name='bp' value={formData.bp} required={false} onChange={handleChange} inputClassName='show' endLabel='mmHg' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Weight:' name='weight' value={formData.weight} required={false} onChange={handleChange} inputClassName='show' endLabel='kg' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='Previous Weight:'
                name='previousWeight'
                value={formData.previousWeight}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                endLabel='kg'
                minWidth='160px'
              />
            </div>
          </div>
          <h3 className='mt-3'>Complaints</h3>
          <div className='row'>
            <div className='col-md-4'>
              <SelectField
                label='Nausea/Vomiting'
                name='nauseaVomiting'
                value={formData.nauseaVomiting}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
            <div className='col-md-4'>
              <SelectField
                label='Bleeding'
                name='bleeding'
                value={formData.bleeding}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Other:' name='otherComplaints' value={formData.otherComplaints} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>

          <div className='d-flex align-items-start py-2' style={{gap: '10px'}}>
            <label htmlFor='scanFinding' className='fw-bold' style={{whiteSpace: 'nowrap', paddingTop: '6px'}}>
              Scan finding:
            </label>
            <textarea className='Textarea' placeholder='Scan finding' id='scanFinding' name='scanFinding' onChange={handleChange} rows='3' cols='100' />
          </div>

          {showTables.investigation && (
            <TemplateTable
              id='investigation'
              title='First Trimester Investigations'
              headers={investigationHeaders}
              rows={investigationRows}
              onRowsChange={(id, newRows) => setInvestigationRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('investigation', setShowTables)}
            />
          )}
        </div>

        {showTables.medication && (
          <TemplateTable
            id='medication'
            title='Medications CHART'
            headers={medicationHeaders}
            rows={medicationRows}
            onRowsChange={(id, newRows) => setMedicationRows(newRows)}
            enableActions={true}
            onNill={() => handleNill('medication', setShowTables)}
          />
        )}

        <div className='d-flex align-items-start py-2' style={{gap: '10px'}}>
          <label htmlFor='additionalAdvice' className='fw-bold' style={{whiteSpace: 'nowrap', paddingTop: '6px'}}>
            Advice:
          </label>
          <textarea className='Textarea' placeholder='add advice' id='additionalAdvice' name='additionalAdvice' onChange={handleChange} rows='4' cols='100' />
        </div>

        <p className='pt-3' style={{fontWeight: '600'}}>
          NEXT APPOINTMENT - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
        </p>

        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
      <div id='secondMonthPregnancyReport'>
        <div id='secondMonthPregnancyReportWrap'>
          <Headers />
          <p class='Dani'></p>
          <div
            className='patient'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '5px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '5px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '5px'}}>
            <h4 style={{fontWeight: 600, color: '#333', marginBottom: '15px'}}>Spontaneous Pregnancy – 2 Month</h4>
          </div>
          <div style={{display: 'flex', marginTop: '5px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>OBSTETRIC SCORE :</h6>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('G:', formData.g)}
            {renderReportfield('P:', formData.p)}
            {renderReportfield('A:', formData.a)}
            {renderReportfield('L:', formData.l)}
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>{renderReportfield('Ectopic:', formData.ecTopic)}</div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>{renderReportfield('GESTATIONAL AGE:', `${formData.gestationalAge ? formData.gestationalAge : ''} Weeks`)}</div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('BP:', `${formData.bp ? formData.bp : ''} mmHg`)}
            {renderReportfield('Weight:', `${formData.weight ? formData.weight : ''} kg`)}
            {renderReportfield('Previous Weight:', `${formData.previousWeight ? formData.previousWeight : ''} kg`)}
          </div>
          <div style={{display: 'flex', marginTop: '5px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>Complaints</h6>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Nausea/Vomiting:', formData.nauseaVomiting)}
            {renderReportfield('Bleeding:', formData.bleeding)}
            {renderReportfield('Other:', formData.otherComplaints)}
          </div>

          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('Scan finding:', formData.scanFinding)}</div>

          {showTables.investigation && (
            <>
              {' '}
              <div style={{display: 'flex', marginTop: '5px'}}>
                <h4 style={{fontWeight: 600, marginRight: '5px'}}>First Trimester Investigations :</h4>
              </div>
              <table
                style={{
                  marginBottom: '5px',
                  border: '1px solid black',
                  width: '100%',
                  textAlign: 'center'
                }}>
                <thead>
                  <tr>{investigationHeaders.map((ele, ind) => renderTableTH(ele.label))}</tr>
                </thead>
                <tbody>
                  {investigationRows.map((row, i) => (
                    <tr key={i}>
                      {renderTableTD(row.investigation)}
                      {renderTableTD(row.result)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}

          {showTables.medication && (
            <>
              {' '}
              <div style={{display: 'flex', marginTop: '5px'}}>
                <h4 style={{fontWeight: 600, marginRight: '5px'}}>Medications CHART :</h4>
              </div>
              <table
                style={{
                  marginBottom: '5px',
                  border: '1px solid black',
                  width: '100%',
                  textAlign: 'center'
                }}>
                <thead>
                  <tr>{medicationHeaders.map((ele, ind) => renderTableTH(ele.label))}</tr>
                </thead>
                <tbody>
                  {medicationRows.map((row, i) => (
                    <tr key={i}>
                      {renderTableTD(row.sno)}
                      {renderTableTD(row.drug)}
                      {renderTableTD(row.genericName)}
                      {renderTableTD(row.dosage)}
                      {renderTableTD(row.freq)}
                      {renderTableTD(row.withFood)}
                      {renderTableTD(row.duration)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}

          <div style={{marginBottom: '5px'}}>
            <div style={{fontWeight: '600', margin: '0 10px 10px 10px'}}>ADVICE:</div>
            <pre style={{margin: '0 10px 10px 10px', fontFamily: 'inherit', whiteSpace: 'pre-wrap'}}>{formData.additionalAdvice}</pre>
          </div>

          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '5px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          </div>
          <p class='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
